import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TwilioSimStatusSelectPageRoutingModule } from './twilio-sim-status-select-routing.module';

import { TwilioSimStatusSelectPage } from './twilio-sim-status-select.page';
import { ComponentsModule } from 'src/components/components.module';
import { CommonLibModule } from 'common-lib';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TwilioSimStatusSelectPageRoutingModule,
    
    ComponentsModule,
    CommonLibModule,
  ],
  declarations: [TwilioSimStatusSelectPage]
})
export class TwilioSimStatusSelectPageModule {}
